import React from 'react';
import PropTypes from 'prop-types';

const CheckedIcon = props => (
  <svg width="21" height="21" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path fillRule="evenodd" clipRule="evenodd" d="M0 10.5C0 16.2988 4.7012 21 10.5 21C16.2988 21 21 16.2988 21 10.5C21 4.7012 16.2988 0 10.5 0C4.7012 0 0 4.7012 0 10.5ZM8.5125 14.0625C8.664 14.2155 8.865 14.2995 9.0795 14.2995C9.294 14.2995 9.495 14.2155 9.6435 14.0655L14.8485 8.862C15.1545 8.55 15.1545 8.046 14.844 7.7325C14.694 7.5825 14.493 7.5 14.28 7.5C14.067 7.5 13.8675 7.5825 13.7145 7.734L9.0795 12.3705L7.365 10.6575C7.215 10.5045 7.014 10.4205 6.7995 10.4205C6.585 10.4205 6.384 10.5045 6.2355 10.6545C6.0825 10.8045 6 11.007 6 11.22C6 11.433 6.0825 11.6355 6.2355 11.7855L8.5125 14.0625Z" fill="white" />
  </svg>
);

CheckedIcon.propTypes = {
  className: PropTypes.string,
  onClick: PropTypes.func,
  onKeyDown: PropTypes.func,
};

CheckedIcon.defaultProps = {
  className: undefined,
  onClick: undefined,
  onKeyDown: undefined,
};

export default CheckedIcon;
